import {Disclosure, DisclosureButton, DisclosurePanel} from '@headlessui/react'
import type {FunctionComponent, HTMLAttributes} from 'react'
import {Fragment} from 'react/jsx-runtime'
import {FaqIconChevronUp} from '~/icons/faq/brg-icon-faq-chevron-up'
import {getTranslation} from '~/localization/translation'
import type {FaqsProps} from '~/types'

interface FaqSectionprops extends HTMLAttributes<HTMLDivElement> {
  language: string
  faqs?: FaqsProps[]
}

const FaqSection: FunctionComponent<FaqSectionprops> = ({language, faqs, ...attributes}) => {
  const translations = getTranslation(language)
  const showFaq = faqs && faqs.length > 0

  return showFaq ? (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map(({question, answer}) => ({
              '@type': 'Question',
              name: question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: `<p>${answer}</p>`,
              },
            })),
          }),
        }}
      />
      <div {...attributes}>
        <div className="flex w-full flex-col items-center justify-center gap-7 mobile:gap-4">
          <h2 className="text-2xl tracking-widest mobile:text-[16px]">{translations.FAQ.title}</h2>
          <div className="flex w-full flex-col gap-5 mobile:gap-3">
            {faqs?.map((item, index) => {
              if (item?.question?.includes('2023')) {
                return null
              }
              return (
                <Fragment key={`${item.question}-${index}`}>
                  <Disclosure
                    as="div"
                    className="rounded-2xl border border-neutral-200 bg-white p-6 shadow-lg mobile:px-3 mobile:pb-2 mobile:pt-5 mobile:shadow-md"
                    defaultOpen={false}
                  >
                    <DisclosureButton className="group flex w-full items-center justify-between gap-4 border-b border-b-white transition-all duration-200 ease-in-out mobile:pb-3 mobile:data-[open]:border-b-gray-300">
                      <h2 className="text-start text-2xl font-normal mobile:text-[16px] mobile:leading-5">
                        {item.question}
                      </h2>
                      <div className="flex size-[50px] shrink-0 items-center justify-center rounded-full border border-black bg-white transition-colors duration-100 ease-in-out group-data-[open]:bg-black mobile:size-[28px]">
                        <FaqIconChevronUp
                          strokeWidth="2"
                          className="rotate-180 transition-all duration-200 ease-in-out group-data-[open]:rotate-[-360deg] mobile:size-3 [&>path]:stroke-black group-data-[open]:[&>path]:stroke-white"
                        />
                      </div>
                    </DisclosureButton>
                    <DisclosurePanel
                      transition
                      className="my-2 origin-top pr-44 text-lg font-light text-gray-700 transition duration-200 ease-in-out data-[closed]:scale-y-0 data-[closed]:opacity-0 tablet:pr-16 mobile:pr-10 mobile:text-sm mobile:leading-[18px] mobile:text-gray-500"
                    >
                      <p>{item.answer}</p>
                    </DisclosurePanel>
                  </Disclosure>
                </Fragment>
              )
            })}
          </div>
        </div>
      </div>
    </>
  ) : null
}

export default FaqSection
